module.exports = __webpack_public_path__ + "media/q&a.fde6755e.webm";